import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/Icon'

class AntDropdownMenuItem extends React.Component {
  shouldComponentUpdate (nextProps, _nextState) {
    return (
      nextProps.segment.name !== this.props.segment.name ||
      nextProps.menuItem.id !== this.props.menuItem.id ||
      nextProps.selected !== this.props.selected
    )
  }

  render () {
    const {
      menuItem,
      segment,
      selected,
      handleLinkClick,
      handleFilterChange,
      setSelectedIndex,
      selectedMenuItemRef,
      handleMouseDown,
      handleMouseUp,
      Link,
      urlTransformer,
    } = this.props

    let renderMenuItem

    const menuItemContent = menuItem.content || menuItem.text
    const itemContent = (
      <div className="icon-wrapper">
        {segment.type === 'icons' && <Icon name={`${segment.iconPrefix}-${menuItem.id}`} />}
        {segment.menuItemContentWrapper ? segment.menuItemContentWrapper(menuItem, menuItemContent) : menuItemContent}
      </div>
    )

    if (menuItem.href) {
      const url = urlTransformer(menuItem.href, segment.name)

      if (url.indexOf('//') !== -1) {
        renderMenuItem = (
          <a
            href={url}
            onClick={(event) => {
              handleLinkClick(event, menuItem.id, segment, true)
            }}
            ref={selected && selectedMenuItemRef}
          >
            {itemContent}
          </a>
        )
      } else {
        renderMenuItem = (
          <Link
            url={url}
            onClick={(event) => {
              handleLinkClick(event, menuItem.id, segment, true)
            }}
            onMouseDown={handleMouseDown}
            onMouseUp={handleMouseUp}
            refToForward={selected ? selectedMenuItemRef : null}
          >
            {itemContent}
          </Link>
        )
      }
    } else {
      renderMenuItem = (
        <div
          className="ant-dropdown-menu-item__content"
          onClick={() => {
            handleFilterChange(menuItem.id, segment, true)
          }}
          ref={selected && selectedMenuItemRef}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
        >
          {itemContent}
        </div>
      )
    }

    return (
      <li
        className={classNames(
          'ant-dropdown-menu-item',
          { selected },
        )}
        key={`item-${menuItem.id}`}
        onMouseEnter={() => {
          setSelectedIndex(segment.name, menuItem.id)
        }}
      >
        {renderMenuItem}
      </li>
    )
  }
}

AntDropdownMenuItem.propTypes = {
  menuItem: PropTypes.object.isRequired,
  segment: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  handleLinkClick: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  handleMouseDown: PropTypes.func,
  handleMouseUp: PropTypes.func,
  setSelectedIndex: PropTypes.func.isRequired,
  selectedMenuItemRef: PropTypes.object.isRequired,
  Link: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  urlTransformer: PropTypes.func,
  menuItemContentWrapper: PropTypes.func,
}

AntDropdownMenuItem.defaultProps = {
  handleMouseDown: () => {},
  handleMouseUp: () => {},
}

export default AntDropdownMenuItem
